import { render } from "./CustomListWidget.vue?vue&type=template&id=4c167d43&scoped=true"
import script from "./CustomListWidget.vue?vue&type=script&lang=js"
export * from "./CustomListWidget.vue?vue&type=script&lang=js"

import "./CustomListWidget.vue?vue&type=style&index=0&id=4c167d43&scoped=true&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c167d43"]])

export default __exports__